<template>
    <div class="m-w12">
        <div class="m-user"><user-info/></div>

        <div class="w12-view">
            <div class="shop-groups">
                <div class="group-item" v-for="(item,index) in shop_group" :key="index" :class="item.clz" @click="see_offer(item.sid);"></div>
            </div> 
            
            <div class="title-w12"></div>
            <p class="notice">获取积分可于商城内兑换奖励，积分仅在本期有效，请注意及时使用！</p>

            <div class="skin-pannel">
                <ul>
                    <li v-for="(item,index) in skin_list" :key="index">
                        <div class="skin-icon"  :class="{'act' : skin_status[item.sid.toLowerCase()+'_flag'] == 1}">
                            <div class="goods-pic" v-tips="item.id"><game-item :locked="true" :id="item.id" :num="1"></game-item></div>
                        </div>
                        <div class="skin-name">
                            {{ item.name }}
                        </div>
                        <div class="status"  :class="{'act' : skin_status[item.sid.toLowerCase()+'_flag'] == 1}"></div>
                    </li>
                </ul>
            </div>

            <div class="skin-shop">
                <div class="list-pannel" v-if="shop_list.length">
                    <div class="list-item" v-for="(item,index) in shop_list" :key="index">
                        <h6>{{ item.giftName }}*{{ item.sendNum }}</h6>

                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="item.gameGiftId"><game-item :locked="true" :id="item.gameGiftId" :num="item.sendNum"></game-item></div>
                            </div>  
                        </div> 
                        
                        <div class="score" v-if="item.amt > 0">
                            <em class="icon-m3b"></em><span class="p-now">{{ item.amt }}</span><span class="p-before">{{ item.showAmt }}</span>
                        </div>
                        <div class="cnt">（{{ skin_status.skin_cnt || 0 }}/{{ item.p1 }}）</div>
                        
                        <div class="u-btn buy" v-if="item.amt > 0" :class="{'dismiss' : item.max == item.orderNum , 'disabled' : skin_status.skin_cnt < item.p1}" @click="exchange(item)"></div>
                        <div class="u-btn apply" v-else :class="{'dismiss' : item.max == item.orderNum , 'disabled' : skin_status.skin_cnt < item.p1}" @click="exchange(item)"></div>

                        <div class="require" v-if="item.p1 > 0">解锁以上换装<b>{{ item.p1 }}</b>个可{{ item.amt > 0 ? '购买' : '领取' }}</div>
                    </div>

                </div>
            </div>

            <div class="invite-view">
                <div class="title-invite"></div>
                <div class="notice">
                    <p>邀请近3期未在阿斗消费过的用户参与本次阿斗，</p>
                    <p>可获得豪华奖励（限领3次）</p>
                </div>

                <div class="u-btn rule" @click="$w12_rule()">查看邀请规则</div>

                <div class="table">
                    <div class="data-table">
                        <table>
                            <tbody>
                                <tr v-for="(item,index) in invite_list" :key="index">
                                    <td style="width: 218px;">{{ index == 0? '本人':('邀请用户' + index) }}</td>
                                    <td style="width: 186px;">{{ item.nickName }}</td>
                                    <td>{{ item.totalPay > 0 ? '是' : '否'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="u-btn invite" @click="call_invite()"></div>

                <div class="reward-list">
                    <div class="reward-item" v-for="n in 3" :key="n">
                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="'PI16'"><game-item :locked="true" :id="'PI16'" :num="1"></game-item></div>
                            </div>  
                        </div>
                        
                        <div class="u-btn apply" 
                        :class="{'dismiss' : ($store.state.userinfo.uflag & invite_flag[n - 1]) == invite_flag[n - 1] , 'disabled' : n > pay_cnt}" @click="apply_reward(n)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.m-w12{
    padding-top: 604px;
}

.m-user{
    width: 750px;
    height: 48px;
    line-height: 48px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-userinfo.png);
}

.w12-view{
    width: 750px;
    min-height: 2382px;
    margin: 0 auto;
    padding-top: 20px;
    background-image: url(~@/assets/images/w12/bg-shop.png),url(~@/assets/images/w12/body.png);
    background-repeat: no-repeat,repeat-y;
    padding-bottom: 300px;
}

.shop-groups{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 130px;
    padding: 0 20px;

    .group-item{
        position: relative;
        width: 343px;
        height: 122px;
        background-repeat: no-repeat;
        background-position: top center;

        &.s-1{
            transform: translateY(9px);
            background-image: url(~@/assets/images/shop/shop-1.png);
        }

        &.s-2{
            background-image: url(~@/assets/images/shop/shop-2.png);
        }        
    }
}

.title-w12{
    width: 750px;
    height: 77px;
    margin: 42px auto 28px;
    background-image: url(~@/assets/images/w12/title-w12.png);    
}

.notice{
    text-align: center;
    font-size: 22px;
    color: #dccdc1;
}

.skin-pannel{
    display: flex;
    align-items: center;
    flex-wrap: wrap; 
    width: 689px;
    height: 241px;
    margin: 10px auto 15px;
    background-image: url(~@/assets/images/w12/skin-pannel.png);

    ul{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap; 
        padding: 20px 10px 0;
        width: 100%;
        box-sizing: border-box;

        li{
            margin: 0 7.5px 20px;
        }
    }

    .skin-icon{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 118px;
        height: 118px;
        background-image: url(~@/assets/images/w12/skin-item.png);

        .goods-pic{
            width: 69px;
            height: 69px;
        }

        &::after{
            content: '';
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba($color: #000000, $alpha: 0.2);
            pointer-events: none;
        }

        &.act::after{
            display: none;
        }
    }

    .skin-name{
        margin-top: 5px;
        text-align: center;
        color: #968777;
    }

    .status{
        width: 48px;
        height: 48px;
        margin: 5px auto 0;
        background-image: url(~@/assets/images/w12/icon-disabled.png);

        &.act{
            background-image: url(~@/assets/images/w12/icon-checked.png);
        }
    }
}

.skin-shop{
    .list-pannel{
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 25px;
        padding: 0 22px;

        .list-item{
            position: relative;
            width: 331px;
            height: 536px; 
            margin: 0 11px 25px;
            padding-top: 42px;
            background-image: url(~@/assets/images/w12/item-pannel.png);
            text-align: center;
            
            &.temp{               
                background-image: url(~@/assets/images/w12/item-temp.png);
            }
        }

        h6{
            height: 2.5em;
            margin-bottom: 12px;
            padding: 0 20px;
            font-size: 28px;
            font-weight: 700;
            color: #7f572d;
            overflow: hidden;
        }

        .goods-detail{
            .goods-wrapper{
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                width: 118px;
                height: 118px;
                margin: 0 auto;
                background-image: url(~@/assets/images/shop/bg-item.png);
            }

            .goods-pic{
                width: 69px;
                height: 69px;
                border: 2px solid #ccae62;
            }
        }

        .cnt{
            position: absolute;
            left: 50%;
            bottom: 200px;
            width: 100%;
            transform: translateX(-50%);
            color: #7f572d;
            text-align: center;
        }

        .score{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;           
           
            .p-now{
                font-size: 28px;
                font-weight: 700;
                color: #d33d27;
            }

            .p-before {
                padding-left: 8px;
                color: #a0938a;
                text-decoration: line-through;
            }            
        }

        .require{
            position: absolute;
            left: 50%;
            bottom: 50px;
            width: 100%;
            transform: translateX(-50%);
            color: #7f572d;
            text-align: center;

            b{
                color: #d33d27;
            }
        }

        .u-btn.apply{
            position: absolute;
            left: 50%;
            bottom: 100px;
            transform: translateX(-50%);
            width: 232px;
            height: 89px;
            margin: 8px auto 0;
            background-image: url(~@/assets/images/w12/btn-apply.png);

            &.disabled{
                background-image: url(~@/assets/images/w12/btn-apply_disabled.png);
            }

            &.dismiss{
                background-image: url(~@/assets/images/w12/btn-apply_dismiss.png);
            }            
        }

        .u-btn.buy{
            position: absolute;
            left: 50%;
            bottom: 100px;
            transform: translateX(-50%);            
            width: 232px;
            height: 89px;
            margin: 8px auto 0;
            background-image: url(~@/assets/images/w12/btn-buy.png);

            &.disabled{
                background-image: url(~@/assets/images/w12/btn-buy_disabled.png);
            }

            &.dismiss{
                background-image: url(~@/assets/images/w12/btn-buy_dismiss.png);
            }             
        }        
    }
}

.invite-view{
    .title-invite{
        width: 750px;
        height: 77px;
        margin: 42px auto 28px;
        background-image: url(~@/assets/images/w12/title-w12_invite.png);           
    }

    .u-btn.rule{
        margin-top: 25px;
        color: #b48453;
        text-decoration: underline;
        text-align: center;      
    }

    .table{
        width: 689px;
        height: 371px;
        margin: 20px auto 0;
        padding-top: 80px;
        background-image: url(~@/assets/images/w12/pannel-table.png);

        .data-table{
            width: 100%;
            font-size: 22px;
            color: #dccdc1;
            text-align: center;

            table{
                width: 100%;
            }

            tr{
                height: 72px;
            }
        }
    }

    .u-btn.invite{
        width: 292px;
        height: 89px;
        margin: 32px auto 0;
        background-image: url(~@/assets/images/w12/btn-invite.png);      
    }    
}

.reward-list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    margin-top: 32px;

    .reward-item{
        width: 211px;
        height: 345px;
        padding-top: 53px;
        background-image: url(~@/assets/images/w12/item-invite_task.png);  
    }

    .goods-detail{
        .goods-wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            width: 118px;
            height: 118px;
            margin: 0 auto;           
            background-image: url(~@/assets/images/shop/bg-item.png);
        }

        .goods-pic{
            width: 69px;
            height: 69px;
            border: 2px solid #ccae62;
        }
    }

    .u-btn.apply{
        width: 192px;
        height: 69px;
        margin: 20px auto 0;
        background-image: url(~@/assets/images/w12/btn-reward.png);

        &.disabled{
            background-image: url(~@/assets/images/w12/btn-reward_disabled.png);
        }

        &.dismiss{
            background-image: url(~@/assets/images/w12/btn-reward_dismiss.png);
        }            
    }    

}
</style>

<script>
import shop_group from '@/components/shopgroup.js'

export default {
    data (){
        return {
            skin_list : [
            { id: 'FU88', name: '玲珑玉姝', sid: 'mc43' },
            { id: 'FV24', name: '白狼封疆', sid: 'ac17' },
            { id: 'FV26', name: '玉门听风', sid: 'bc21' },
            { id: 'FV28', name: '蛊玉长生', sid: 'ac40' },
            { id: 'FV36', name: '锦玉芳华', sid: 'ac12' },                                                         
            ],
            skin_status : { skin_cnt : 0, },
            shop_list : [],
            invite_list : [],          
            shop_group : shop_group.list,
            shop_dic : shop_group.shop_dic,
            sid : 1,
            invite_flag : [1,2,4],
            pay_cnt : 0,
        }
    },
    mounted(){
        this.render();
        if(this.$store.state.userinfo.zid){
            this.get_friend_list();
            this.skin_query();
        }
    },
    computed:{
        w12_list (){
            return this.$store.state.w12_list;
        },        
    },
    watch: {
        w12_list : {
            handler(newVal, oldVal) {
                this.shop_list = newVal;
                //this.render();
            },
            deep: true
        },                
    },      
    methods : {
        render(){
            this.$get(ajax_url_map.w12_list,{
                success : (res) => {
                    this.shop_list = res.data;
                    this.$store.commit("$_setW12List", res.data);
                },
                error : () => {}, 
            },{
                orderNum : true,
            })
        },
        skin_query(){
            this.$get(ajax_url_map.w12_query,{
                success : (res) => {
                    if(res.data)this.skin_status = res.data;
                },
                error : () => {},                 
            })
        },
        get_friend_list(){
            this.$get(ajax_url_map.w12_invite_list,{
                success : (res) => {
                    this.invite_list = res.data;
                    this.pay_cnt = res.data.filter(ele => ele.totalPay > 0 && ele.uid != 0).length;

                    if(res.data.filter(ele => ele.totalPay == 0 && ele.uid == 0).length){
                        this.pay_cnt = 0;
                    }
                },
                error : () => {},                  
            })
        },
        exchange(item){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            if(item.max == item.orderNum){
                return this.$toast('已兑换至上限');
            }

            let type = item.amt > 0 ? 2 : 1;

            if(this.skin_status.skin_cnt < item.p1){
                return this.$toast('解锁换装数量不达标，无法'+ (type == 2 ? '购买' : '领取') +'哦~');
            }
           
            item.amt ? this.$w12_comfirm({ gid : item.id , groupid : item.groupId , sendNum : item.sendNum , type : type , cost : item.amt, item : item,}) : this.apply(item);
        },
        apply(item){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            this.$post(ajax_url_map.w12_skin_apply,{
                success : (data) => {
                    this.$msg_modal('操作成功，奖励将直接发放至您的军师邮件，请注意查收。');

                    //todo
                    this.render();
                },
                error : (data) => {
                    this.$msg_modal(data.message);
                }
            },{
                id : item.id,
                gid : item.groupId,
            })
        },         
        call_invite(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }
            
            this.$get(ajax_url_map.w12_invite,{
                success : (res) => {
                    let shareTxt = res.data.koudai  ? (res.data.koudai + res.data.url) : res.data.url;
                    this.$w12_copy({ shareTxt : shareTxt });                    
                },
                error : () => {},                    
            },{
                key : 'share'
            })
        },
        see_offer (sid){
            this.$router.push({ name: 'detail', params: { sid: sid }});
        },         
        apply_reward(n){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }
            
            this.$post(ajax_url_map.w12_invite_gift,{
                success : (res) => {
                    this.$msg_modal('领取成功');  
                    this.$update_evt();
                },
                error : (rej) => {
                    this.$msg_modal(rej.message);    
                },                    
            },{
                id : n,
            })            
        }
    }, 
}
</script>